module.exports = __webpack_public_path__ + "static/media/MenuButton.5f81a38c.jpg";